/* istanbul ignore file */
/**
 * Created by rathompson on 11/3/21
 * File: SelectedRolesTable
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useContext, useMemo, VFC } from 'react'
import {
  ConnectedTable,
  TableProvider,
  ConnectedTableLayout,
} from '@panwds/react-table'
import { Body } from '@panwds/react-ui'
import TableHeader from '../../../../../common/components/table/TableHeader'

import {
  LABEL_HEADER_ROLE_DESC,
  LABEL_HEADER_ROLE_NAME,
  LABEL_SELECTED_ROLES_TITLE,
} from '../../../../constants/LabelConstants'
import V5TableWrapper from '../../../../../common/components/table/V5TableWrapper'
import GlobalContext from '../../../../../common/context/GlobalContext'

const SelectedRolesTable: VFC<{
  app: any
}> = ({ app }) => {

  const { iamReducer } = useContext(GlobalContext)
  const { roleMap, customRoleMap } = iamReducer

  const aggregatedRoleMap = useMemo(() => {
    return { ...roleMap, ...customRoleMap }
  }, [roleMap, customRoleMap])

  const columns = useMemo(() => [
    {
      accessor: (row: any) => row.display_name || row.value,
      Header: LABEL_HEADER_ROLE_NAME,
      width: 232,
      id: 'name',
      Cell: ({ value }: any) => <div className='tw-p-1 tw-flex-tw-flex-col tw-justify-start tw-h-full'><Body>{value}</Body></div>
    },
    {
      accessor: (row: any) => aggregatedRoleMap[row?.name]?.app_descriptions?.[app?.id] || aggregatedRoleMap[row?.name]?.description,
      Header: LABEL_HEADER_ROLE_DESC,
      width: 232,
      id: 'description',
      Cell: ({ value }: any) => <div className='tw-p-1'><Body>{value}</Body></div>
    }
  ], [app?.id, aggregatedRoleMap])

  return (
    <V5TableWrapper>
      <TableProvider
        columns={columns}
        data={app?.roles}
      >
        <TableHeader title={LABEL_SELECTED_ROLES_TITLE}/>
        <div className='cm-overflow-auto cm-max-h-80'>
          <ConnectedTableLayout>
            <ConnectedTable
              showFooter={false}
            />
          </ConnectedTableLayout>
        </div>
      </TableProvider>
    </V5TableWrapper>
  )
}

export default SelectedRolesTable
